import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import MinimalDumbo from '../../../../DeviationViews/Dumbo/EditorDumbo';
import s from './Journal.scss';
const JournalThumbReactView = (props)=>/*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        style: {
            width: props.width,
            height: props.height
        }
    }, /*#__PURE__*/ React.createElement(MinimalDumbo, _extends({}, props)));
JournalThumbReactView.displayName = 'JournalThumbReactView';
export default JournalThumbReactView;
